module.exports = __webpack_public_path__ + "static/assets/slgr_logo.80076424.png";